import { partirDescripcion } from '@/modules/cotizador/useCotizador'
import { Aviso } from '@/shared/ui/Aviso/Aviso'
import { Cargando } from '@/shared/ui/Estados/Cargando'
import { fechaHora } from '@/shared/utilidades/formato'

import { cantidadLegible, useMovimientosDeSobrantes } from './useSobrantes'
import estilos from './PaginaSobrantes.module.css'

const DESTINO: Record<string, string> = {
  otra_orden: 'A la orden',
  descarte: 'Descarte',
  otro: 'Otro motivo',
}

/**
 * Por dónde entró y salió cada cosa, lo más reciente arriba. Es solo de la
 * app: los sobrantes no se reingresan en World Office (0313).
 */
export function MovimientosDeSobrantes() {
  const { data = [], isLoading, error } = useMovimientosDeSobrantes()

  if (isLoading) return <Cargando mensaje="CONSULTANDO MOVIMIENTOS RECIENTES..." />
  if (error) return <Aviso tipo="error">{(error as Error).message}</Aviso>
  if (data.length === 0) {
    return <p className={estilos.vacio}>Todavía no ha entrado ni salido nada.</p>
  }

  return (
    <div className={estilos.tablaCaja}>
      <table className={estilos.tabla}>
        <thead>
          <tr>
            <th>Cuándo</th>
            <th>Material</th>
            <th className={estilos.num}>Cantidad</th>
            <th>Detalle</th>
            <th>Quién</th>
          </tr>
        </thead>
        <tbody>
          {data.map((m) => {
            const { nombre } = partirDescripcion(m.descripcion)
            const entra = m.tipo === 'entrada'
            return (
              <tr key={m.id}>
                <td className={estilos.cuando}>{fechaHora(m.hecho_en)}</td>
                <td>
                  <span className={estilos.nombre}>{nombre}</span>
                </td>
                <td className={`${estilos.num} ${entra ? estilos.entra : estilos.sale}`}>
                  {entra ? '+' : '−'}
                  {cantidadLegible(Math.abs(m.cantidad))}{' '}
                  <span className={estilos.unidad}>{m.unidad ?? ''}</span>
                </td>
                <td className={estilos.detalleCelda}>
                  {entra
                    ? `Sobró en ${m.orden_trabajo ?? 'una orden'} y se verificó`
                    : `${DESTINO[m.destino ?? 'otro']}${m.orden_trabajo ? ` ${m.orden_trabajo}` : ''}`}
                  {m.motivo && !m.motivo.startsWith('Asignado a la orden') && (
                    <span className={estilos.motivo}>{m.motivo}</span>
                  )}
                </td>
                <td>{m.hecho_por ?? '—'}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
